/* eslint-disable */
import React, { useState, useEffect } from 'react'
import 'antd/dist/antd.css'
import { useDispatch } from 'react-redux'
import { connect } from 'react-redux'
import { Breadcrumb, Radio, Carousel, message, Spin, BackTop } from 'antd'
import { UpOutlined } from '@ant-design/icons';
import ServiceCard from 'components/ServiceCard'
import { storageData, clearstorageData } from 'redux/storage'
import { useTranslation } from 'react-i18next'
import { GetSubscriptions, frontendGetSubscriptions, guestGetService } from 'api/hub';
import { history } from 'redux/store'

const ServiceDetail = (props) => {
  // Basic Setting
  const dispatch = useDispatch()
  // i18n language switch
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [statuscode, setstatuscode] = useState({
    status_desc_en: "",
    status_desc_tw: ""
  })

  // Get Subscription
  const [Subscription, setSubscription] = useState({
    service_media:"",
    service_name_en: "",
    service_name_tw:"",
    vendor_name: "",
    period_start: "",
    period_end: "",
    tag: "",
    rate: 0,
    reviews: 0,
    summary: "",
    service_info_data_en: [
      {
        service_name:""
      }
    ],
    service_info_data_tw: [
      {
        service_name:""
      }
    ]
  })
  // Get Service
  const [Service, setService] = useState({
    "page": 1,
    "status": "C51",
    "cr_date": "2022-04-28 06:45:50.252000",
    "cr_user": "vas_system@wiadvance.com",
    "version": "V1.0",
    "page_cnt": 1,
    "upd_date": "2022-04-28 06:45:50.252000",
    "upd_user": "vas_system@wiadvance.com",
    "prod_host": null,
    "vendor_id": "VC1234567890123456789",
    "media_data": [
      {
        "seq": 1651306689688000000,
        "media_url": "https://www.youtube.com/watch?v=OR9hFGJqmx8",
        "media_type": "mediaLink",
        "service_id": "SS1234567890123456789",
        "org_file_name": null,
        "sys_file_name": null,
        "media_link_name": "操作說明"
      },
      {
        "seq": 1651306690078000000,
        "media_url": "https://www.youtube.com/watch?v=nNQXl4uotCg",
        "media_type": "mediaLink",
        "service_id": "SS1234567890123456789",
        "org_file_name": null,
        "sys_file_name": null,
        "media_link_name": "應用示範"
      },
      {
        "seq": 1651307318864000000,
        "media_url": null,
        "media_type": "screenshot",
        "service_id": "SS1234567890123456789",
        "org_file_name": null,
        "sys_file_name": null,
        "media_link_name": null
      },
      {
        "seq": 1651307318864000000,
        "media_url": null,
        "media_type": "screenshot",
        "service_id": "SS1234567890123456789",
        "org_file_name": null,
        "sys_file_name": null,
        "media_link_name": null
      },
      {
        "seq": 1651307318864000000,
        "media_url": null,
        "media_type": "screenshot",
        "service_id": "SS1234567890123456789",
        "org_file_name": null,
        "sys_file_name": null,
        "media_link_name": null
      }
    ],
    "record_cnt": 1,
    "service_id": "SS1234567890123456789",
    "stage_host": null,
    "support_url": "http://www.google.com",
    "contact_data": [
      {
        "ext": null,
        "seq": 1651306608094000000,
        "email": "parts.lin@wiadvance.com",
        "title": "清潔工",
        "language": "zh-cht",
        "last_name": "林",
        "phone_num": "0212345678",
        "first_name": "建合",
        "mobile_num": "0912345678",
        "service_id": "SS1234567890123456789",
        "contact_type": "support",
        "country_code": "886"
      }
    ],
    "publish_date": "2022-04-28",
    "publish_type": "automatic",
    "service_type": "app",
    "support_data": {
      "version": "V1.0",
      "support_url": "http://www.google.com",
      "copyright_en": "Parts",
      "copyright_tw": "林建合",
      "publish_date": "2022-04-28",
      "service_email": "parts.lin@wiadvance.com",
      "service_contract": "https://vasdevmediafile.z13.web.core.windows.net/appAdmin/SS1234567890123456789/WIA_serviceContract.pdf",
      "privacy_policy_url": "http://tw.yahoo.com"
    },
    "overview_data": [
      {
        "service_id": "SS1234567890123456789",
        "service_sla": "95",
        "tls_version": "1.3",
        "contract_num": "87654321",
        "security_dscr": null,
        "code_scan_dscr": null,
        "security_report": "Y",
        "code_scan_report": "Y",
        "service_sla_dscr": null,
        "tls_version_dscr": null,
        "subscription_type": "period30",
        "cloud_platform_sla": "99.99",
        "cloud_platform_code": "aws",
        "cloud_platform_dscr": "Amazon AWS",
        "cloud_platform_sla_dscr": null,
        "subscription_type_description_en": {
          "for_admin": "Subscription (auto-renew) - 30 days",
          "for_tenant": "Subscription (auto-renew) - 30 days",
          "for_vendor": "Subscription (auto-renew) - 30 days"
        },
        "subscription_type_description_tw": {
          "for_admin": "訂閱(自動續約)-30天",
          "for_tenant": "訂閱(自動續約)-30天",
          "for_vendor": "訂閱(自動續約)-30天"
        }
      }
    ],
    "vendor_name_en": "WiAdvance Technology Corporation",
    "vendor_name_tw": "緯謙科技股份有限公司",
    "page_record_set": 1,
    "oauth_service_id": null,
    "privacy_policy_url": "http://tw.yahoo.com",
    "agreed_wia_contract": "Y",
    "service_info_data_en": [
      {
        "seq": 1651299254043000000,
        "keyword": "experience,life,Pomodoro,privacy,security,achievement system",
        "summary": "In \"Life UP\", the process of completing tasks is no longer boring. According to the priority of tasks, you can get \"experience points\" and \"gold coins\" rewards for completing tasks.",
        "copyright": "Parts",
        "price_info": "$900 per month ",
        "service_id": "SS1234567890123456789",
        "description": "In \"Life UP\", the process of completing tasks is no longer boring. According to the priority of tasks, you can get \"experience points\" and \"gold coins\" rewards for completing tasks.\nThe experience point reward can improve your \"level\" of different attributes; you can use gold coins to go to the store to buy the set \"self-reward\" goods.\nReaching certain conditions, such as reaching the specified level and completing the task for how many days in a row, it is also possible to unlock \"achievements\" and obtain more rewards.",
        "service_name": "Life UP",
        "promotional_text": null
      }
    ],
    "service_info_data_tw": [
      {
        "seq": 1651299254043000000,
        "keyword": "經驗值,人生,番茄鍾,隱私安全,成就系統",
        "summary": "在《人升》中，你完成任務的過程不再枯燥無味，根據任務的輕緩急重，完成任務你可以獲得『經驗值』、『金幣』獎勵。",
        "copyright": "林建合",
        "price_info": "每月 $900",
        "service_id": "SS1234567890123456789",
        "description": "在《人升》中，你完成任務的過程不再枯燥無味，根據任務的輕緩急重，完成任務你可以獲得『經驗值』、『金幣』獎勵。\n經驗值獎勵能提高你不同屬性的『等級』；你可以使用金幣去商店購買設定好的「自我獎勵」商品。\n達成一定的條件，如達到指定等級、完成任務連續多少天，還有可能解鎖『成就』，而從獲取更多的獎勵。",
        "service_name": "人升",
        "promotional_text": null
      }
    ],
    "expected_publish_date": 0,
    "status_description_en": [
      {
        "for_admin": "Ready For Sale",
        "for_tenant": "Ready For Sale",
        "for_vendor": "Ready For Sale"
      }
    ],
    "status_description_tw": [
      {
        "for_admin": "可供銷售",
        "for_tenant": "可供銷售",
        "for_vendor": "可供銷售"
      }
    ],
    "service_type_description_en": [
      {
        "for_admin": "Software Services (SaaS)",
        "for_tenant": "Software Services (SaaS and API)",
        "for_vendor": "Software Services (SaaS)"
      }
    ],
    "service_type_description_tw": [
      {
        "for_admin": "應用程式",
        "for_tenant": "軟體型服務(SaaS與API)",
        "for_vendor": "應用程式"
      }
    ]
  })
  const [options1, setOptions1] = useState({
    'tw':[
      { label:'全部', value: 'all' },
    ],
    'en':[
      { label:'all', value: 'all' },
    ]
  });
  useEffect(()=>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString)
    const serviceId = urlParams.get('serviceId')?urlParams.get('serviceId'):""
    const tenantId = JSON.parse(localStorage.getItem('LoginInfo')).tenantId
    const operator_id = JSON.parse(localStorage.getItem('LoginInfo')).operator_id
    let anchorElement = document.getElementById('top');
    // 如果對應id的錨點存在，就跳轉到錨點
    console.log(anchorElement)
    if(anchorElement) { anchorElement.scrollIntoView({block: 'start', behavior: 'smooth'}); }
    // console.log(serviceId)
    setLoading(true)
    
    // dispatch(frontendGetSubscriptions({tenant_id:tenantId,service_id:serviceId}))
    dispatch(GetSubscriptions(
      {
        "tenant_id": tenantId,
        "ip_address": "1.1.1.1",
        "operator_id": operator_id,
        "service_id": serviceId,
      }
      ))
    .then(
        res => { 
          if(res.data.subscriptions?.lookup_data){
            if(options1?.tw.length<2){
              setOptions1({
                'tw':[...options1.tw,...res.data.subscriptions?.lookup_data.map(i=> {
                return { label: i.status_desc_tw, value: i.lookup_code }
                })],
                'en':[...options1.en,...res.data.subscriptions?.lookup_data.map(i=> {
                  return { label: i.status_desc_en, value: i.lookup_code }
                }
                )]
              })
              // setOptions1([...options,...res.data.subscriptions?.lookup_data.map(i=> {return { label: localStorage.getItem('lang')==='en'?i.status_desc_en:i.status_desc_tw, value: i.lookup_code }})])
            }
          }
          if(Object.keys(res).length > 2){
            setSubscription(() => res.data.subscriptions.subscription_data[0]) 
          }
          setLoading(false)
         }
        )
    dispatch(guestGetService({service_id:serviceId})).then(
      res => { 
          console.log(res.data.services[0])
          setService(()=>(res.data.services[0]))
        }
      )
      }
  ,[])

  const options = [
    { label: `${t('Subscription.Detail.overview')}`, value: 'Id1' },
    { label: `${t('Subscription.Detail.pricing')}`, value: 'Id2' },
    { label: `${t('Subscription.Detail.details_and_support')}`, value: 'Id3' },
    // { label: `${t('Subscription.Detail.ratings_and_reviews')}`, value: '4' , disabled: true}
  ]

  const onChange = e => {
    console.log(e.target.value);
    let anchorElement = document.getElementById(e.target.value === 'Id1' ? 'top' : e.target.value);
    // 如果對應id的錨點存在，就跳轉到錨點
    console.log(anchorElement)
    if(anchorElement) { anchorElement.scrollIntoView({block: (e.target.value === 'Id1' ? 'start' : e.target.value === 'Id2' ? 'center' :'end'), behavior: 'smooth'}); }
  }
  const onNav=()=>{
    const url = new URL(window.location.href)
    const searchValue = url.searchParams.get("search")?url.searchParams.get("search"):""
    history.push(`/portal/service?search=${searchValue}`)
  }
  const contentStyle = {
    height: '300px',
    color: '#fff',
    lineHeight: '280px',
    textAlign: 'center',
    background: '#C7C7C7',
  };
  
  return (
    <>
       <div className='innerlayout' id='top' style={{padding: '36px 0 0 130px'}}>
       <Spin tip={t('Global.Loading')} spinning={loading} style={{padding: '36px 0 0 130px'}}>
       {!loading?
       <>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>WiAdvance App Market</Breadcrumb.Item>
            <Breadcrumb.Item >{t('Global.member_center')}</Breadcrumb.Item>
            <Breadcrumb.Item><a style={{color:'#7DB926'}} onClick={onNav}>{t('Menu.subscriptions')}</a></Breadcrumb.Item>
            <Breadcrumb.Item className='lastchild'>
              {localStorage.getItem('lang')==='en'?`${Subscription.service_name_en}`:`${Subscription.service_name_tw}`}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className='headtitle'>
          {localStorage.getItem('lang')==='en'?`${Subscription.service_name_en}`:`${Subscription.service_name_tw}`}
          </div>
          <ServiceCard data={{
            ...Subscription,
            'sub_status': {
              status_desc_en: options1?.en?.filter(i=>{return i.value == Subscription.status})[0]?.label,
              status_desc_tw: options1?.tw?.filter(i=>{return i.value == Subscription.status})[0]?.label
            }
            }} type='detail'></ServiceCard>
          <div className='servicedetailradio' id='Id1'>
            <Radio.Group 
                defaultValue="Id1"
                optionType="button"
                buttonStyle="solid"
                options={options}
                onChange={onChange} 
                />
          </div>
          <div className='servicedescription'>
            <div className='left'>
              <div className='title'>
                {t('Subscription.Detail.product_overview')}
              </div>
              <div className='par'>
                {Service.service_info_data_tw ? localStorage.getItem('lang')==='en'?
                Service.service_info_data_en[0].promotional_text ?<div  style={{paddingBottom:'10px'}}><div contentEditable='false' dangerouslySetInnerHTML={{ __html: `${Service.service_info_data_en[0].promotional_text}` }}></div><br/></div>:
                null:
                Service.service_info_data_tw[0].promotional_text ?<div  style={{paddingBottom:'10px'}}><div contentEditable='false' dangerouslySetInnerHTML={{ __html: `${Service.service_info_data_tw[0].promotional_text}` }}></div><br/></div>:
                null
                : null}
                <div contentEditable='false' dangerouslySetInnerHTML={{ __html: `${Service.service_info_data_tw ? localStorage.getItem('lang')==='en'?`${Service.service_info_data_en[0].description}`:`${Service.service_info_data_tw[0].description}` :''}` }}></div>
                
              </div>
            </div>
            <div className='right' style={{minWidth:'450px'}}>
              <div className='title'>
                {t('Subscription.Detail.preview')}
              </div>
                <div className='carousel'>
                  <Carousel autoplay>
                    {
                      Service.media_data?
                      Service.media_data.sort((a, b) => {
                        if(a.media_type === 'mediaLink'){
                          return -1
                        }
                        if (a.media_type === 'screenshot'){
                          return 1;
                        }
                        return 0;
                      }
                      ).map(item=>{
                        if(item.media_type === 'mediaLink') {
                          return <><div><iframe width='100%' style={{aspectRatio: '16/9'}} src={item.media_url.replace("watch?v=","embed/")} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div></>
                        } else if(item.media_type === 'screenshot') {
                          return <><div><img width='100%' style={{aspectRatio: '16/9'}} src={item.media_url} alt="photo"></img></div></>
                        }
                      }):<></>
                    
                    }
                  </Carousel>
                </div>
                <div className='title' id='Id2'>
                    {t('Subscription.Detail.pricing')}
                </div>
                <div className='cost'>
                  <div className='costinfo'>
                  <div contentEditable='false' dangerouslySetInnerHTML={{ __html: `${localStorage.getItem('lang')==='en'?`${Service.service_info_data_en[0].price_info}`:`${Service.service_info_data_tw[0].price_info}`}` }}></div>
                  </div>
                </div>
                <div className='sup' id='Id3'>
                    <div className='title'>
                      {t('Subscription.Detail.details_and_support')}
                    </div>
                    <div className='supblock'>
                        <div className='marginblock'>
                          {Service.support_data_v2? Service.support_data_v2.map(i=>{
                          if(!i.info[localStorage.getItem('lang')].col_val){
                            return(<></>)
                          }
                          else if(i.type === "mailto"){
                              return(
                                <div className='block'>
                                  <div className='left'>
                                    {i.info[localStorage.getItem('lang')].col_name}
                                  </div>
                                  <a className='right' onClick={()=>window.open(`mailto:${i.info[localStorage.getItem('lang')].link1}`)}>
                                    {i.info[localStorage.getItem('lang')].link1_title}
                                  </a>
                                </div>
                              )
                            }
                            else if(i.type === "append_alink" || i.type === "alink"){
                              return(
                              <div className='block'>
                              <div className='left'>
                                {i.info[localStorage.getItem('lang')].col_name}
                              </div>
                              <div className='right' style={{color:'#3F3F3F'}}>
                                
                                {i.info[localStorage.getItem('lang')].col_val.split(/\s?{link[1-9]}+{link[1-9]_title(.*?)}\s?/g).map((item,index)=>{
                                  console.log(index,item)
                                if(index % 2 === 1){
                                  console.log((index+1) / 2 )
                                  return (<a className='right' onClick={()=>window.open(`${i.info[localStorage.getItem('lang')][`link${(index+1) / 2}`]}`)}>
                                    {i.info[localStorage.getItem('lang')][`link${(index+1) / 2}_title`]}
                                  </a>)
                                }else{
                                  {console.log(item)}
                                  return (
                                    <>{item}</>
                                  )
                                }
                              })
                              }
                              </div>
                              </div>
                              )
                            }
                            else{
                              return(
                              <div className='block'>
                                <div className='left'>
                                  {i.info[localStorage.getItem('lang')].col_name}
                                </div>
                                <div className='rightg'>
                                  {i.info[localStorage.getItem('lang')].col_val}
                                </div>
                              </div>
                              )
                            }
                            
                          }):
                          null}
                        </div>
                      </div>
                  </div>
            </div>
          </div>
          </>
          :<>
            <Breadcrumb separator=">">
            <Breadcrumb.Item>WiAdvance App Market</Breadcrumb.Item>
            <Breadcrumb.Item >{t('Global.member_center')}</Breadcrumb.Item>
            <Breadcrumb.Item><a style={{color:'#7DB926'}}>{t('Menu.subscriptions')}</a></Breadcrumb.Item>
          </Breadcrumb>
          <div className='servicedetailradio' id='Id1'>
            <Radio.Group 
                defaultValue="Id1"
                optionType="button"
                buttonStyle="solid"
                options={options}
                onChange={onChange} 
                />
          </div>
          </>
          }
          </Spin>
      </div>
    </>
  )
}
// 將store中的items值傳綁到props上
const mapStateToProps = store => (
  { storeData: store.storeData }
)
const mapDispatchToProps = dispatch => {
  return {
    storageData: (payload) => {
      dispatch(storageData(payload))
    },
    clearstorageData: () => {
      dispatch(clearstorageData())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ServiceDetail)